import {renderPage} from '@smartfire/js-block-engine';
import React from 'react';

if((<any>window).wp) {
    // Create WP proxy to avoid issues on ESModule imports
    (<any>window).wp = new Proxy((<any>window).wp, {
        get(target: any, p: string | symbol): any {
            if(target[p]) {
                return target[p];
            } else {
                if(p === "elements") {
                    return React;
                }
                return {}; // Empty Library
            }
        }
    });
}

renderPage();